export default __webpack_public_path__ + "static/media/email_callcenter_icon.014079f8.svg";